import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";

/**
 * ChipInput
 *
 * An email (or any token) chip input used in LeadManagement's
 * Add Lead, Edit Lead, and Email Panel modals.
 * Promotes the existing renderChipInput render-function to a proper
 * memoised component so it doesn't re-create on every parent render.
 *
 * Props:
 *   items         string[]        — current list of chips
 *   inputValue    string          — controlled input value
 *   onInputChange (val: string) => void
 *   onAdd         () => void      — called when Enter/Tab/+ is triggered
 *   onRemove      (item: string) => void
 *   placeholder   string          — input placeholder (default: "email@example.com")
 *
 * Usage:
 *   <ChipInput
 *     items={form.buyerEmails}
 *     inputValue={emailInput}
 *     onInputChange={setEmailInput}
 *     onAdd={addFormEmail}
 *     onRemove={removeFormEmail}
 *   />
 */
const ChipInput = React.memo(function ChipInput({
  items,
  inputValue,
  onInputChange,
  onAdd,
  onRemove,
  placeholder = "email@example.com",
}) {
  return (
    <div>
      {/* Chip list */}
      <div
        style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 6 }}
      >
        {items.map((item) => (
          <span
            key={item}
            style={{
              background: "rgba(201,176,122,0.12)",
              border: "1px solid rgba(201,176,122,0.25)",
              borderRadius: 4,
              padding: "3px 8px",
              fontSize: 10,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            {item}
            <button
              onClick={() => onRemove(item)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "rgba(201,176,122,0.6)",
                fontSize: 11,
                padding: 0,
              }}
            >
              ×
            </button>
          </span>
        ))}
      </div>

      {/* Input + add button */}
      <div style={{ display: "flex", gap: 6 }}>
        <input
          className={styles.input}
          style={{ flex: 1 }}
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => onInputChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Tab") {
              e.preventDefault();
              onAdd();
            }
          }}
        />
        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          style={{ padding: "6px 14px", fontSize: 11 }}
          onClick={onAdd}
        >
          +
        </button>
      </div>
    </div>
  );
});

export default ChipInput;
